import PropTypes from 'prop-types';
import React from 'react';
import Image from '$partials/media/image';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const FullBleedImageModule = ({
    image
}) => {
    return (
        <div className='aspect-[1.1/1] sm:aspect-[1.4/1] md:aspect-[1.7/1] lg:aspect-[2/1]'>
            <Image {...image} />
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    image: PropTypes.object,
};

FullBleedImageModule.propTypes = propTypes;

export default FullBleedImageModule;
